/** ----工具类方法----*/
export default {
  // 文件大小显示转换
  fmtSize(val, toFixed = 2) {
    if (!val) {
      return '0B'
    } else if (val < 1024) {
      return `${val}B`
    } else if (val < (1024 * 1024)) {
      return `${(val / 1024).toFixed(toFixed)}KB`
    } else if (val < (1024 * 1024 * 1024)) {
      return `${(val / 1024 / 1024).toFixed(toFixed)}MB`
    } else {
      return `${(val / 1024 / 1024 / 1024).toFixed(toFixed)}GB`
    }
  },

  // 显示转换，根据value 查找label
  valueToLabel(source, val, key = 'value', res = 'label') {
    const obj = source.find((x) => { return x[key] === val })
    return obj[res]
  },

  // 判断是否为json字符串
  isJsonString(str) {
    try {
      if (typeof JSON.parse(str) === 'object') {
        return true
      }
    } catch (e) {
      // eslint-disable-next-line no-console
      console.log('非json字符串')
    }
    return false
  },

  /** -------------------对象或数组深拷贝---------------------------**/
  deepCopy(source) {
    const sourceCopy = source instanceof Array ? [] : {}
    for (const item in source) {
      sourceCopy[item] = typeof source[item] === 'object' && source[item] !== null
        ? this.deepCopy(source[item]) : source[item]
    }
    return sourceCopy
  },

  /** ------------------- 按 key 排序 ---------------------------**/
  compare(property) {
    return function (obj1, obj2) {
      const value1 = obj1[property]
      const value2 = obj2[property]
      if (value1 < value2) { return -1 }
      if (value1 > value2) { return 1 }
      return 0
    }
  },
  /** ------------------- 单数组去重 ---------------------------**/
  unique(origin) {
    const arr = []
    for (let i = 0; i < origin.length; i++) {
      if (arr.indexOf(origin[i]) === -1) {
        arr.push(origin[i])
      }
    }
    return arr
  },
  /** ------------------- 数组拖拽后重新排序 ---------------------------**/
  drag(arr, oldIndex, newIndex) {
    const removedArr = [
      ...arr.slice(0, oldIndex),
      ...arr.slice(oldIndex + 1, arr.length)
    ]
    return [
      ...removedArr.slice(0, newIndex),
      arr[oldIndex],
      ...removedArr.slice(newIndex, removedArr.length)
    ]
  },
  /** ------------------- hash路由获取某个query参数值---------------------------**/
  getQueryVal(hash, key) {
    const query = hash.replace(/.*\?/, '')
    const reg = new RegExp(`(^|&)${key}=([^&]*)(&|$)`)
    const r = query.substr(0).match(reg)
    if (r !== null) {
      return decodeURI(r[2])
    }
    return ''
  },
  /** ------------------- 获取随机整数 ---------------------------**/
  getRandomInt(min, max) {
    const minCeil = Math.ceil(min)
    const maxFloor = Math.floor(max)
    return Math.floor(Math.random() * (maxFloor - minCeil) + minCeil) // 不包含最大值，包含最小值
  },
  /** ------------------- 判断两个简单数组是否一致，有顺序要求 ---------------------------**/
  isArraysEqual(a, b) {
    return a.length === b.length && a.every((v, i) => v === b[i])
  }
}
